import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DataCompany } from '../interfaces/lip-data-company';
import { Data } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class IpInfoSharedCompanyService {
  private companyInfo: BehaviorSubject<DataCompany> =
    new BehaviorSubject<DataCompany>({
      name : '',
      country : '',
      currentType: '',
      language : '',
      logo : '',
      //url: ''
    });

  getSharingInfo() {
    
    return this.companyInfo.asObservable();
  }

  
  setSharingInfo(data: DataCompany) {
    
    this.companyInfo.next(data);
  }

  
}
